//react
import React, { Component } from 'react';
import ReactGA from 'react-ga';

//assets
import './accordion.css';

//functions
import * as Utilities from '../../utilities';

class Accordion extends Component {
	constructor() {
		super();

		this.state = {
			accordionOpen: false,
			timeout: null,
		};

		this.accordionToggle = this.accordionToggle.bind(this);
	}

	accordionToggle(name) {
		const collapse = this.refs.collapse;
		const collapseInner = this.refs.collapseInner;

		if (this.state.accordionOpen) {
			collapse.style.height = collapseInner.clientHeight + 'px';

			clearTimeout(this.state.timeout);

			this.setState({
				timeout: setTimeout(function() {
					collapse.style.height = 0;
				}, 0),
			});

			ReactGA.event({
				category: 'accordion',
				action: 'close',
				label: name,
			});
		} else {
			collapse.style.height = collapseInner.clientHeight + 'px';

			clearTimeout(this.state.timeout);

			this.setState({
				timeout: setTimeout(function() {
					collapse.style.height = 'auto';
				}, 500),
			});

			ReactGA.event({
				category: 'accordion',
				action: 'open',
				label: name,
			});
		}

		this.setState({
			accordionOpen: !this.state.accordionOpen,
		});
	}

	render() {
		const data = this.props.data;
		const cultureFallback = 'uk'; //UK set as the default culture
		let cultureRequested = cultureFallback;
		let title = null;
		let __htmlBody = null;

		if (data) {
			//get culture if one requested
			if (this.props.culture) {
				if (data[this.props.culture]) {
					cultureRequested = this.props.culture;
				}
			}

			//get content for requested culture
			if (data[cultureRequested][this.props.name]) {
				if (data[cultureRequested][this.props.name].title) {
					title = data[cultureRequested][this.props.name].title;
				}

				if (data[cultureRequested][this.props.name].__htmlBody) {
					__htmlBody = data[cultureRequested][this.props.name].__htmlBody;
				}
			}

			//if no content for requested culture get content for fallback culture
			if (!title || !__htmlBody) {
				if (!title && data[cultureFallback][this.props.name].title) {
					title = data[cultureFallback][this.props.name].title;
				}

				if (!__htmlBody && data[cultureFallback][this.props.name].__htmlBody) {
					__htmlBody = data[cultureFallback][this.props.name].__htmlBody;
				}
			}
		}

		if (!title || !__htmlBody) {
			return null;
		}

		let accordionTitleStyle = 'accordion__title hwa';

		if (this.state.accordionOpen) {
			accordionTitleStyle += ' accordion__title--open';
		}

		return (
			<div className="accordion">
				<button className={accordionTitleStyle} onClick={() => this.accordionToggle(this.props.name)}>{Utilities.removeWidow(title)}</button>
				<div className="accordion__collapse hwa" ref="collapse">
					<div className="accordion__body" dangerouslySetInnerHTML={{__html: __htmlBody}} ref="collapseInner" />
				</div>
			</div>
		);
	}
}

export default Accordion;



// WEBPACK FOOTER //
// ./src/components/accordion/accordion.js